export const DiscountTypes = { PERCENT: 1, FIXED_AMOUNT: 2 };
Object.freeze(DiscountTypes);
